// @ts-strict-ignore
import { EmployeeGroup, Employee } from '@fc-core';

export function extractUsersGroups(
  employList: Employee[],
  userGroups: EmployeeGroup[],
) {
  if (employList?.length) {
    return employList.map((employee) => {
      return {
        ...employee,
        groups: userGroups
          ? userGroups
              ?.filter((group) => group?.employees?.includes(employee.id))
              ?.map((group) => group.id)
          : [],
        fullGroups: userGroups
          ? userGroups
              ?.filter((group) => group?.employees?.includes(employee.id))
              ?.map((group) => group.id)
              ?.map((id) => userGroups.find((group) => group.id === id))
          : [],
      } as Employee;
    });
  }
  return employList;
}
